import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import ClearIcon from '@material-ui/icons/Clear';
import PropTypes from 'prop-types';
import moment from 'moment';
import dig from 'object-dig';
import People from '@material-ui/icons/People';
import clsx from 'clsx';
import Send from '@material-ui/icons/Send';
import ReceiptIcon from '@material-ui/icons/Receipt';
import FaceIcon from '@material-ui/icons/Face';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import MonetizationOn from '@material-ui/icons/MonetizationOn';
import EditIcon from '@material-ui/icons/Edit';
import LinkMaterial from '@material-ui/core/Link';
import DoneIcon from '@material-ui/icons/Done';
import { URL } from '~/config/uri';
import PaperAvatar from '../components/PaperAvatar';
import Button from '~/components/Button';
import GridItem from '~/components/GridItem';
import GridContainer from '~/components/GridContainer';
import ChipItem from '~/components/Chip';
import useStyles from './styles';
import PushModal from '../components/PushModal';
import InputShow from '~/components/InputShow';
import PersonRecord from '~/records/PersonRecord';
import countriesEnum from '~/enums/countriesEnum';
import { reasonToUseOptions } from '~/config/customQuery/userConfig';
import DialogBillings from './containers/DialogBillings';
import DeleteIcon from '@material-ui/icons/Delete';
import GetAppIcon from '@material-ui/icons/GetApp';
import DialogPackages from './containers/DialogPackages';
import InputLabel from '@material-ui/core/InputLabel';
import Chip from '@material-ui/core/Chip';
import ManagePackages from '~/containers/Users/ManagePackages';
import {
  showPerson,
  editPerson,
  newPerson,
  peoples,
  newMedicalAppointments,
  examsPerson,
  showPack,
  showSpecialty,
} from '~/config/routes';
import {
  packagesColors,
  packageOptions,
  genresOptions,
} from '~/config/constants';
import Can from '~/contexts/Can';
import RemoveRedEyeIcon from '@material-ui/icons/RemoveRedEye';
import IconButton from '~/components/Button/IconButton';

import Typography from '@material-ui/core/Typography';
import Request from '~/providers/Request';
import ShowDoc from './MedicalRecords/MedicalRecordEvolution/ShowDoc.jsx';
import ModalDelete from '~/components/ModalDelete';
import isPresent from '~/utils/isPresent';
import MuiInputFile from '~/components/Input/MuiInputFile';
import { AbilityContext } from '~/contexts/Can';
import { Tooltip } from '@material-ui/core';

const attrName = (attr) => PersonRecord.hummanAttributeName(attr);

function ClientInfo({ record, loading, setRecord, idClient }) {
  const classes = useStyles();
  const [modalVisible, setModalVisible] = useState(false);
  const [modalBillingsVisible, setModalBillingsVisible] = useState(false);
  const [modalPackagesVisible, setModalPackagesVisible] = useState(false);
  const [isManagePackages, setIsManagePackages] = useState(false);
  const [isShowFile, setIsShowFile] = useState(false);
  const [fileShow, setFileShow] = useState(null);
  const [docs, setDocs] = useState([]);
  const [docsStatus, setDocsStatus] = useState('pending');
  const [reload, setReload] = useState(false);
  const [fileRemove, setFileRemove] = useState(null);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const { t } = useTranslation();

  const ability = useContext(AbilityContext);

  useEffect(() => {
    async function getMedicalRecordEvolution() {
      await Request.get(`/admin/doc/list/${idClient}`, {})
        .then((response) => {
          console.log(response.data);
          setDocs(response.data);
        })
        .catch((e) => {
          console.error(e);
        });
    }
    async function getDocStatus() {
      await Request.get(
        `/admin/status/${idClient}`,
        {},
        { normalizeJSON: false }
      )
        .then((response) => setDocsStatus(response.data.status))
        .catch((e) => {
          console.error(e);
        });
    }
    if (idClient) {
      getMedicalRecordEvolution();
      getDocStatus();
    }
  }, [idClient, reload]);
  async function showFile(file) {
    setFileShow(file);
    setIsShowFile(true);
  }

  async function onDelete() {
    setLoadingDelete(true);

    Request.del(`/admin/doc/${fileRemove.id}`, null, { normalizeJSON: false })
      .then(() => {
        setFileRemove(null);
        setLoadingDelete(false);
        setReload(!reload);
        toast.success(t('delete-toast-success'));
      })
      .catch((e) => {
        console.error(e);
        setLoadingDelete(false);
      });
  }

  async function donwloadFile(file) {
    const authorizationToken = await Request.getAuth();
    fetch(`${URL}/admin/doc/${file.id}`, {
      method: 'GET',
      headers: new Headers({
        Authorization: `Bearer ${authorizationToken}`,
      }),
    })
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.setAttribute('href', url);
        a.setAttribute('download', file.name);
        a.click();
      });
  }

  async function rejectDocs(docs) {
    const isPlural = docs.length > 1;
    docs.map(async (item, index) => {
      await Request.put(`/admin/status/${item.id}`, {
        user_id: record.get('uuid'),
        status: 'rejected',
        index,
      }).catch((e) => {
        console.error(e);
      });
      Request.del(`/admin/doc/${item.id}`, null, { normalizeJSON: false })
        .then(() => {
          setFileRemove(null);
          setLoadingDelete(false);
          setReload(!reload);
        })
        .catch((e) => {
          console.error(e);
          setLoadingDelete(false);
        });
    });
    if (isPlural) toast.success(t('reject-doc-toast-sucess-plural'));
    else toast.success(t('reject-doc-toast-sucess'));
  }

  async function acceptDocs(docs) {
    const isPlural = docs.length > 1;
    docs.map((item, index) =>
      Request.put(`/admin/status/${item.id}`, {
        user_id: record.get('uuid'),
        status: 'verified',
        index,
      })
        .then(() => {
          setReload(!reload);
        })
        .catch((e) => {
          console.error(e);
        })
    );
    if (isPlural) toast.success(t('verify-doc-toast-sucess-plural'));
    else toast.success(t('verify-doc-toast-sucess'));
  }

  const uploadFiles = async (files) => {
    if (isPresent(files)) {
      const formData = new FormData();
      formData.append('file[]', files[0]);
      fetch(`${URL}/admin/doc/${idClient}`, {
        method: 'POST',
        body: formData,
        headers: { Authorization: `Bearer ${await Request.getAuth()}` },
      })
        .then(() => {
          setReload((prevReload) => !prevReload);
          toast.success('Documento enviado com sucesso!');
        })
        .catch((e) => {
          console.log(e);
          toast.error('Falha ao enviar documento!');
        });
    }
  };

  return (
    <>
      {modalBillingsVisible && (
        <DialogBillings
          user={record}
          handleClose={() => setModalBillingsVisible(false)}
        />
      )}
      {modalPackagesVisible && (
        <DialogPackages
          user={record}
          handleClose={() => setModalPackagesVisible(false)}
        />
      )}
      <PaperAvatar
        Icon={People}
        iconColor="blue"
        title={record.get('name')}
        loading={loading}
        photo={`${URL}/public/user_face/${record.get('uuid')}.jpg?size=140`}
        actions={
          <>
            <Link
              style={{ textDecoration: 'none', margin: 2 }}
              to={peoples.spec}
            >
              <Button variant="outlined" color="primary">
                {t('action.back')}
              </Button>
            </Link>
            {record.get('id') && (
              <Can I="edit" a="Peoples">
                <Link
                  style={{ textDecoration: 'none', margin: 2 }}
                  to={editPerson.reverse({ id: record.get('id') })}
                >
                  <Button color="orange" endIcon={<EditIcon />}>
                    {t('action.edit')}
                  </Button>
                </Link>
              </Can>
            )}
            <Can I="new" a="Peoples">
              <Link
                style={{ textDecoration: 'none', margin: 2 }}
                to={newPerson.spec}
              >
                <Button color="green">{t('action.new')}</Button>
              </Link>
            </Can>
            <Can I="new" a="MedicalAppointments">
              <Link
                style={{ textDecoration: 'none', margin: 2 }}
                to={`${newMedicalAppointments.spec}?user_id=${record.get(
                  'id'
                )}`}
              >
                <Button color="green">
                  {t('person.extras.newMedicalAppointments')}
                </Button>
              </Link>
            </Can>
            {record.get('id') && (
              <Can I="exam" a="Peoples">
                <Link
                  style={{ textDecoration: 'none', margin: 2 }}
                  to={examsPerson.reverse({ id: record.get('id') })}
                >
                  <Button color="second">{t('person.extras.newExam')}</Button>
                </Link>
              </Can>
            )}
            <Can I="new" a="Pushs">
              <Button
                color="orange"
                style={{ margin: 2 }}
                onClick={() => setModalVisible(true)}
              >
                <Send />
              </Button>
            </Can>
          </>
        }
      >
        <div className={clsx(classes.root)}>
          <GridContainer spacing={2}>
            <GridItem xs={4} md={1}>
              <InputShow label={attrName('id')} value={record.get('id')} />
            </GridItem>
            <GridItem xs={12} md={4}>
              <InputShow label={attrName('name')} value={record.get('name')} />
            </GridItem>
            <GridItem xs={12} md={4}>
              <InputShow
                label={attrName('email')}
                value={record.get('email')}
              />
            </GridItem>
            <GridItem xs={12} md={3}>
              <InputShow
                label={attrName('cell_phone')}
                value={record.get('cell_phone')}
              />
            </GridItem>
            <GridItem xs={12} md={3}>
              <InputShow label={attrName('cpf')} value={record.get('cpf')} type="cpf" />
            </GridItem>
            <GridItem xs={12} md={3}>
              <InputShow
                value={
                  record.get('created_at')
                    ? moment(record.get('created_at')).format('LL')
                    : ''
                }
                label={attrName('created_at')}
              />
            </GridItem>
            <GridItem xs={12} md={3}>
              <InputShow
                value={
                  record.get('last_access')
                    ? moment(record.get('last_access')).format('LL')
                    : ''
                }
                label={attrName('last_access')}
              />
            </GridItem>
            <GridItem xs={12} md={3}>
              <InputShow
                label={attrName('expires_at')}
                value={
                  record.get('expires_at')
                    ? moment(record.get('expires_at')).format('LL')
                    : ''
                }
              />
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={12} md={3}>
              <InputShow
                label={attrName('born_date')}
                value={
                  record.get('born_date')
                    ? moment(record.get('born_date')).format('LL')
                    : ''
                }
              />
            </GridItem>
            <GridItem xs={12} md={3}>
              <InputShow
                label={attrName('gender')}
                value={genresOptions[record.get('gender')]}
              />
            </GridItem>
            <GridItem xs={12} md={6}>
              <InputShow
                label={attrName('reason_to_use')}
                value={reasonToUseOptions[record.get('reason_to_use')]}
              />
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={12} md={4}>
              <InputShow
                label={attrName('platform')}
                value={record.get('platform')}
              />
            </GridItem>
            <GridItem xs={6} md={4}>
              <InputShow
                label={attrName('nationality')}
                value={
                  countriesEnum().objects('id', 'nationality')[
                    record.get('nationality')
                  ] || ''
                }
              />
            </GridItem>
            <GridItem xs={6} md={2}>
              <InputShow
                label={attrName('doctor_interest')}
                value={record.get('doctor_interest')}
                type="boolean"
              />
            </GridItem>

            <GridItem xs={6} md={2}>
              <InputShow
                label={attrName('has_benefits_club')}
                value={record.get('has_benefits_club')}
                type="boolean"
              />
            </GridItem>

            <GridItem xs={6} md={4}>
              <InputShow
                label={attrName('device_language')}
                value={record.get('device_language')}
              />
            </GridItem>
            <GridItem xs={6} md={4}>
              <InputShow
                label={attrName('store_location')}
                value={record.get('store_location')}
              />
            </GridItem>
            <GridItem xs={6} md={4}>
              <InputShow
                label={attrName('app_version')}
                value={record.get('app_version')}
              />
            </GridItem>
            <GridItem xs={4}>
              <InputShow
                type="object"
                digObject={['name']}
                label={attrName('partner')}
                value={record.get('partner')}
              />
            </GridItem>
            <GridItem xs={4}>
              <InputShow
                type="object"
                digObject={['name']}
                label={attrName('partner_supplier')}
                value={record.get('partner_supplier')}
              />
            </GridItem>
            <GridItem xs={4}>
              <InputShow
                type="object"
                digObject={['name']}
                label={attrName('corporate_partner')}
                value={record.get('corporate_partner')}
              />
            </GridItem>
            <GridItem xs={4}>
              <InputShow
                type="object"
                digObject={['name']}
                label={attrName('owner_partner')}
                value={record.get('owner_partner')}
              />
            </GridItem>
            <GridItem xs={4}>
              <InputLabel shrink>{'Dependente de'}</InputLabel>
              <br />
              {record.get('dependent_owners').map((user, i) => (
                <Chip
                  key={i}
                  icon={<FaceIcon />}
                  label={user.name}
                  component={LinkMaterial}
                  href={showPerson.reverse({ id: user.id })}
                  style={{ cursor: 'pointer' }}
                  target="_blank"
                  color="primary"
                  variant="outlined"
                  onDelete={() => {}}
                  deleteIcon={<OpenInNewIcon />}
                />
              ))}
            </GridItem>
          </GridContainer>

          <GridContainer>
            <GridItem xs={12} sm={4} md={4} lg={4} xl={4}>
              <InputShow
                type="object"
                digObject={['postal_code']}
                label={attrName('postal_code')}
                value={record.get('address')}
              />
            </GridItem>
            <GridItem xs={12} sm={4} md={4} lg={4} xl={4}>
              <InputShow
                type="object"
                digObject={['name']}
                label={attrName('city')}
                value={
                  record.get('address')?.city
                    ? record.get('address')?.city
                    : {
                        name: `${record.get('address')?.city_name} - ${
                          record.get('address')?.state_uf
                        }`,
                      }
                }
              />
            </GridItem>
            <GridItem xs={12} sm={4} md={4} lg={4} xl={4}>
              <InputShow
                type="object"
                digObject={['neighborhood']}
                label={attrName('neighborhood')}
                value={
                  record.get('address')?.city
                    ? record.get('address')
                    : { neighborhood: record.get('address')?.neighborhood }
                }
              />
            </GridItem>
          </GridContainer>

          <GridContainer>
            <GridItem xs={12} sm={10} md={10} lg={10} xl={10}>
              <InputShow
                type="object"
                digObject={['street']}
                label={attrName('street')}
                value={record.get('address')}
              />
            </GridItem>
            <GridItem xs={12} sm={2} md={2} lg={2} xl={2}>
              <InputShow
                type="object"
                digObject={['number']}
                label={attrName('number')}
                value={record.get('address')}
              />
            </GridItem>
          </GridContainer>

          <Can I="list_package" a="Peoples">
            <GridContainer>
              <GridItem xs={12} sm={12} md={12} lg={12} xl={12}>
                <InputLabel shrink>{attrName('packs_enable')}</InputLabel>
                <br />

                {record.get('packs') &&
                  record
                    .get('packs')
                    .map((item, index) => (
                      <ChipItem
                        key={index}
                        label={packageOptions[item]}
                        colorHex={packagesColors[item]}
                      />
                    ))}
                {record.get('packs').length <= 0 && (
                  <Chip
                    label={t('person.extras.noPacks')}
                    variant="outlined"
                    color="secondary"
                  />
                )}
              </GridItem>
            </GridContainer>
          </Can>

          <Can I="list_package" a="Peoples">
            <GridContainer>
              <GridItem xs={12} sm={12} md={12} lg={12} xl={12}>
                <InputLabel shrink>{attrName('specialties')}</InputLabel>
                <br />

                {record.get('specialties_packs') &&
                  record
                    .get('specialties_packs')
                    .map((item) => (
                      <Chip
                        label={dig(item, 'name')}
                        key={item.specialty_id}
                        component={LinkMaterial}
                        href={showSpecialty.reverse({ id: item.specialty_id })}
                        style={{ cursor: 'pointer', marginRight: 5 }}
                        target="_blank"
                        color="primary"
                        onDelete={() => {}}
                        deleteIcon={<OpenInNewIcon />}
                      />
                    ))}
                {record.get('specialties_packs').length <= 0 && (
                  <Chip
                    label={t('person.extras.noSpecialties')}
                    variant="outlined"
                    color="secondary"
                  />
                )}
              </GridItem>
            </GridContainer>
          </Can>

          <Can I="list_package" a="Peoples">
            <GridContainer>
              <GridItem xs={12} sm={12} md={12} lg={12} xl={12}>
                <InputLabel shrink>{attrName('packPackages')}</InputLabel>
                <br />

                {record.get('packs_packages') &&
                  record.get('packs_packages').map((item) => (
                    <Chip
                      label={dig(item, 'name')}
                      key={item.id}
                      component={LinkMaterial}
                      href={showPack.reverse({ id: item.pack_id })}
                      style={{
                        cursor: 'pointer',
                        marginRight: 5,
                        backgroundColor: packagesColors['pack'],
                      }}
                      target="_blank"
                      color="primary"
                      onDelete={() => {}}
                      deleteIcon={<OpenInNewIcon />}
                    />
                  ))}
                {record.get('packs_packages').length <= 0 && (
                  <Chip
                    label={t('person.extras.noPack_packages')}
                    variant="outlined"
                    color="secondary"
                  />
                )}
              </GridItem>
            </GridContainer>
          </Can>

          <Can I="list_package" a="Peoples">
            <GridContainer>
              <GridItem xs={12} sm={3} md={3} lg={3} xl={3}>
                <Button
                  color="purple"
                  onClick={() => setIsManagePackages(true)}
                >
                  {t('person.extras.manage_packages')}
                </Button>
              </GridItem>
              <GridItem xs={12} sm={1} md={1} lg={1} xl={1}>
                <Button
                  color="green"
                  disabled={loading}
                  onClick={() => setModalBillingsVisible(true)}
                >
                  <ReceiptIcon />
                </Button>
              </GridItem>
              <GridItem xs={12} sm={1} md={1} lg={1} xl={1}>
                <Button
                  color="primary"
                  disabled={loading}
                  onClick={() => setModalPackagesVisible(true)}
                >
                  <MonetizationOn />
                </Button>
              </GridItem>
            </GridContainer>
          </Can>

          <GridContainer>
            <GridItem xs={12} md={12}>
              <InputShow
                label={attrName('signup_messages')}
                value={record.get('signup_messages')}
                multiline={true}
              />
            </GridItem>
          </GridContainer>

          <GridContainer>
            <GridItem xs={12} md={12}>
              <InputShow
                label={attrName('device_info')}
                value={record.get('device_info')}
                multiline={true}
              />
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12} lg={12} xl={12}>
              <InputLabel shrink>
                {t('medical_records.attributes.docs')}
              </InputLabel>
              {docs.map((item) => {
                return (
                  <Typography variant="subtitle1" key={item.id}>
                    <IconButton
                      tooltip={t('action.show')}
                      onClick={() => showFile(item)}
                      Icon={RemoveRedEyeIcon}
                      iconColor="green"
                    />
                    <IconButton
                      tooltip={t('action.download')}
                      onClick={() => donwloadFile(item)}
                      Icon={GetAppIcon}
                      iconColor="blue"
                    />
                    {item.name}
                  </Typography>
                );
              })}
            </GridItem>
            <GridItem md={12}>
              <div
                style={{
                  marginTop: '-10px',
                  marginLeft: '0px',
                }}
                className={clsx(classes.buttons)}
              >
                {ability.can('new', 'ClientInfoDocuments') && (
                  <MuiInputFile
                    style={{ marginRight: '10px' }}
                    multiple={false}
                    label={t('dropzone_file_placeholder')}
                    accept={'image/*'}
                    onChange={(files) => {
                      uploadFiles(files);
                    }}
                    text="CARREGAR"
                  />
                )}
                {docs.length > 0 && (
                  <>
                    {ability.can('accept', 'ClientInfoDocuments') && (
                      <Button
                        style={{
                          marginRight: '10px',
                        }}
                        tooltip={t('action.acceptDocs')}
                        Icon={DoneIcon}
                        disabled={docsStatus === 'verified'}
                        onClick={() => {
                          const confirmBox = window.confirm(
                            'Deseja realmente aceitar os documentos?'
                          );
                          if (confirmBox === true) {
                            acceptDocs(docs);
                          }
                        }}
                        color="green"
                      >
                        {' '}
                        Aceitar{' '}
                      </Button>
                    )}
                    {ability.can('delete', 'ClientInfoDocuments') && (
                      <Tooltip
                        placement="bottom"
                        title={t('corporation.extras.rejectDocs')}
                      >
                        <span>
                          <Button
                            tooltip={t('corporation.extras.rejectDocs')}
                            Icon={ClearIcon}
                            disabled={docsStatus === 'verified'}
                            color="red"
                            onClick={() => {
                              const confirmBox = window.confirm(
                                'Deseja realmente rejeitar e excluir os documentos?'
                              );
                              if (confirmBox === true) {
                                rejectDocs(docs);
                              }
                            }}
                          >
                            {' '}
                            Excluir
                          </Button>
                        </span>
                      </Tooltip>
                    )}
                  </>
                )}
              </div>
            </GridItem>
          </GridContainer>
          {record.get('role') === 'doctor' && (
            <>
              <GridContainer>
                <GridItem xs={12} md={2}>
                  <InputShow
                    label={attrName('crm')}
                    value={record.get('crm')}
                  />
                </GridItem>
                <GridItem xs={12} md={2}>
                  <InputShow
                    label={attrName('crp')}
                    value={record.get('crp')}
                  />
                </GridItem>
              </GridContainer>

              <GridContainer>
                <GridItem xs={12} md={12}>
                  <InputLabel shrink>
                    {t('person.attributes.doctor_specialties')}
                  </InputLabel>
                  {record.get('specialties') &&
                    record
                      .get('specialties')
                      .map((item) => (
                        <Chip
                          style={{ marginRight: 5 }}
                          key={item.id}
                          label={item.name}
                          color="primary"
                        />
                      ))}
                  {record.get('specialties').length <= 0 && (
                    <Chip
                      label={t('person.extras.noSpecialties')}
                      variant="outlined"
                      color="secondary"
                    />
                  )}
                </GridItem>
              </GridContainer>
            </>
          )}
        </div>
      </PaperAvatar>
      <PushModal
        open={modalVisible}
        onClose={() => setModalVisible(false)}
        name={record.get('name')}
        id={record.get('id')}
      />
      <ManagePackages
        user={record}
        handleClose={() => setIsManagePackages(false)}
        isOpen={isManagePackages}
        onUpdateAddons={(packageUsers) => {
          setRecord(
            record.updateAttributes({
              packs: packageUsers.addonPacks,
              specialties_packs: packageUsers.specialtiesPacks,
              packs_packages: packageUsers.packsPackages,
            })
          );
        }}
      />
      <></>
      <ModalDelete
        modal={isPresent(fileRemove)}
        isLoading={loadingDelete}
        message={'Deseja realmente excluir o documento?'}
        buttonText={t('action.remove')}
        deleteAction={onDelete}
        onClose={() => {
          setFileRemove(null);
        }}
      />
      <ShowDoc
        isOpen={isShowFile}
        file={fileShow}
        handleClose={() => {
          setFileShow(null);
          setIsShowFile(false);
        }}
      />
    </>
  );
}

ClientInfo.propTypes = {
  loading: PropTypes.bool,
  record: PropTypes.instanceOf(PersonRecord),
};

export default React.memo(ClientInfo);
